export default __webpack_public_path__ + "static/media/portfolio-178.5165bb3a.jpg";